<template>
  <TimeslotAuthLayout>
    <TimeslotResetPasswordForm v-if="screen === 'reset'" />
    <TimeslotResetOTPForm v-if="screen === 'otp'" />
    <!--    <TimeSlotChangePasswordForm  /> -->
    <TimeSlotSuccess
      v-if="screen === 'success'"
      :message="'You have successfully reset your password'"
    />
  </TimeslotAuthLayout>
</template>

<script>
import TimeslotResetPasswordForm from "@/components/forms/TimeslotResetPasswordForm";
import TimeslotAuthLayout from "@/components/layout/TimeslotAuthLayout";
import TimeSlotSuccess from "@/components/forms/TimeSlotSuccess";
import { mapState } from "vuex";
import TimeslotResetOTPForm from "@/components/forms/TimeslotResetOTPForm";
export default {
  name: "ResetPassword",
  components: {
    TimeSlotSuccess,
    TimeslotResetOTPForm,
    TimeslotResetPasswordForm,
    TimeslotAuthLayout
  },
  computed: {
    ...mapState({
      screen: state => state.auth.resetScreen
    })
  }
};
</script>

<style scoped></style>
